// extracted by mini-css-extract-plugin
export default {"card":"notLiveCampaign--card--IubVjAGD","statCol":"notLiveCampaign--statCol--DCVnttVL"};